import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { api } from "../utils/api";

const getLeads = async ({ categoryId, statusId, ordering, filters, dateRange, pageParam, leadsPerStatus, editedLeads, infinite, kanban = false }) => {
  if (pageParam) {
    const res = await api.get(pageParam);

    // Filter out leads that already exist (IE: if the user edited their email, but the next pagination fetches it because of the ordered-by)
    return {
      data    : editedLeads?.size > 0 ? res.data.filter(lead => !editedLeads.has(lead.id)) : res.data,
      nextUrl : res.headers['x-next-url'],
    }
  }
  
  const params = new URLSearchParams();

  if (leadsPerStatus) {
    params.append('leads_per_status', leadsPerStatus);
  }
  else {
    params.append('page_size', 10);
    //! HAOHAOHAO CHANGE TO 25 DEFAULT
  
    if (ordering) {
      if (ordering.includes('full_name')) {
        const dir = ordering[0] === '-' ? '-' : '';
        params.append('ordering', dir + 'normalized_name');
      }
      else {
        // TODO -> ask pnegro about this change
        params.append('ordering', ordering.includes('status_id') ? ordering.slice(0, -3) : ordering);
      }
    }

    statusId && params.append('status', statusId);
  
    filters?.forEach(filter => {
      params.append(filter.field + (filter.match === 'contains' ? '_contains' : ''), filter.value);
    });

    dateRange?.forEach(range => {
      params.append(range.field, range.value);
    });
  }

  const res = await api.get(kanban ? `/leads/kanban/?category_id=${categoryId}&${params.toString()}` : `/leads/?category_id=${categoryId}&${params.toString()}`);

  if (infinite) {
    return { data: res.data, nextUrl: res.headers['x-next-url'] }
  }
  else {
    return res.data;
  }
}

export default function useLeadsKanban({ categoryId, ordering, filters, editedLeads, leadsPerStatus, ...props }) {
  return useQuery({ queryKey: ['leads-kanban', categoryId], queryFn: () => getLeads({ categoryId, ordering, filters, editedLeads, leadsPerStatus, kanban: true, ...props }) });
}

// ['leads-kanban', cateogory_id, status_id]

export function useLeadsInfinite({ categoryId, ordering, filters, editedLeads, dateRange, leadsPerStatus, ...props}) {
  return useInfiniteQuery({ queryKey: ['leads', categoryId, ordering || 'none', filters || 'none', dateRange || 'none'], queryFn: ({ pageParam }) => getLeads({ categoryId, ordering, filters, pageParam, editedLeads, leadsPerStatus, dateRange, infinite: true }), ...props, getNextPageParam: lastPage => lastPage?.nextUrl !== 'None' ? lastPage.nextUrl : null });
}

export function useLeadsStatus({ statusId, ...props }) {
  return useInfiniteQuery({ queryKey: ['leads-status', statusId], queryFn: ({ pageParam }) => getLeads({ pageParam, statusId, infinite: true }), ...props, getNextPageParam: lastPage => lastPage?.nextUrl !== 'None' ? lastPage.nextUrl : null });
}
